// Using fetch instead of axios since we are not doing so many requests here

export const GET = async (path) => {
  const res = await fetch(path)
  return res
}
